import {resources} from "../../../../core/models/resource/resources";

export const advertisementIntegrationsPageResourceParams = resources['advertisement-integrations'];
